<script setup lang="ts">
import { onBeforeUnmount, onMounted } from "vue";
import { FrappeUIProvider } from "frappe-ui";
import { token } from "@/lib/api";
import { connectLive, disconnectLive } from "@/lib/live";

onMounted(() => {
  if (token.value) connectLive();
  // A tab returning from the background may have missed frames; reconnecting
  // pulls a fresh snapshot.
  document.addEventListener("visibilitychange", onVisibility);
});

function onVisibility() {
  if (document.visibilityState === "visible" && token.value) connectLive();
}

onBeforeUnmount(() => {
  document.removeEventListener("visibilitychange", onVisibility);
  disconnectLive();
});
</script>

<template>
  <FrappeUIProvider>
    <RouterView />
  </FrappeUIProvider>
</template>
